// this will not change anymore so it's faster to put this as constant in UI
const OvertimeRateType = [
    {rateType: 1, description: 'Base + Premium', paidOption: true},
    {rateType: 2, description: 'Base Only', paidOption: true},
    {rateType: 3, description: 'Premium Only', paidOption: true},
    {rateType: 4, description: 'Not Applicable', paidOption: false}
]

export default OvertimeRateType